var exports = {
  "DD": "LoginPage.module__title___cXhjMF",
  "FE": "LoginPage.module__loginContainer___cXhjMF",
  "eZ": "LoginPage.module__loginNotice___cXhjMF",
  "Zd": "LoginPage.module__form___cXhjMF",
  "aK": "LoginPage.module__formLinks___cXhjMF",
  "nf": "LoginPage.module__link___cXhjMF",
  "x": "LoginPage.module__ssoBlock___cXhjMF",
  "Mm": "LoginPage.module__ssoPane___cXhjMF",
  "ie": "LoginPage.module__ssoSubtitle___cXhjMF",
  "gM": "LoginPage.module__ssoButtonLabel___cXhjMF",
  "Sx": "LoginPage.module__ssoCallbackActions___cXhjMF",
  "Sf": "LoginPage.module__ssoRetryButton___cXhjMF",
  "Rl": "LoginPage.module__ssoBackButton___cXhjMF",
  "uL": "LoginPage.module__ssoProcessingHint___cXhjMF",
};

module.exports = exports;
